import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "kn-page" }
const _hoisted_2 = {
  id: "table-container",
  class: "p-d-flex p-flex-row bml-table-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_BMLTable = _resolveComponent("BMLTable")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ProgressSpinner, {
          key: 0,
          class: "kn-progress-spinner"
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
      start: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('managers.bml.title')), 1)
      ]),
      end: _withCtx(() => [
        _createVNode(_component_Button, {
          icon: "fa-solid fa-arrows-rotate",
          class: "p-button-text p-button-rounded p-button-plain",
          onClick: _ctx.loadAllData
        }, null, 8, ["onClick"])
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_BMLTable, {
        tableData: _ctx.allLovs,
        headerTitle: _ctx.$t('managers.bml.lovsTitle'),
        loading: _ctx.loading,
        dataType: "lovs",
        onRowSelected: _ctx.onRowSelect,
        onRowUnselected: _ctx.onRowUnselect
      }, null, 8, ["tableData", "headerTitle", "loading", "onRowSelected", "onRowUnselected"]),
      _createVNode(_component_BMLTable, {
        tableData: _ctx.allDrivers,
        headerTitle: _ctx.$t('managers.bml.drivers'),
        loading: _ctx.loading,
        dataType: "analyticalDrivers",
        onRowSelected: _ctx.onRowSelect,
        onRowUnselected: _ctx.onRowUnselect
      }, null, 8, ["tableData", "headerTitle", "loading", "onRowSelected", "onRowUnselected"]),
      _createVNode(_component_BMLTable, {
        tableData: _ctx.allDocuments,
        headerTitle: _ctx.$t('managers.datasetManagement.documents'),
        loading: _ctx.loading,
        dataType: "documents",
        onRowSelected: _ctx.onRowSelect,
        onRowUnselected: _ctx.onRowUnselect
      }, null, 8, ["tableData", "headerTitle", "loading", "onRowSelected", "onRowUnselected"])
    ])
  ]))
}